import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { TopNavbarModule } from './top-navbar/top-navbar.module';
import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { SideNavbarModule } from './side-navbar/side-navbar.module';
import { SideNavbarComponent } from './side-navbar/side-navbar.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import {MatSidenavModule} from '@angular/material/sidenav';
//import {MatToolbarModule} from '@angular/material/toolbar'; 
//import {MatIconModule} from '@angular/material/icon'
//import {MatListModule} from '@angular/material/list';
import { FrontPageModule } from './front-page/front-page.module';
import { OrganisationModule } from './organisation/organisation.module';
import { MaterialModule } from './shared/material/material.module';
import { EducationModule } from './education/education.module';
import { ProgrammeModule } from './programme/programme.module';
import { CourseModule } from './course/course.module';
import { SearchModule } from './search/search.module';
import { StudyModuleModule } from './study-module/study-module.module';
import { CrossStudyModule } from './cross-study/cross-study.module';


@NgModule({
  declarations: [
    AppComponent,
    TopNavbarComponent,
    SideNavbarComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    MarkdownModule.forRoot(),
    TopNavbarModule,
    SideNavbarModule,
    SharedModule,
    BrowserAnimationsModule,
    //MatSidenavModule,
    //MatToolbarModule,
    //MatIconModule,
    //MatListModule,
    FrontPageModule,
    SearchModule,
    ProgrammeModule,
    CrossStudyModule,//pidä ennen organisationModulea
    OrganisationModule,
    EducationModule,
    CourseModule,
    StudyModuleModule, 
    MaterialModule,
    AppRoutingModule// Pidä tämä viimeisenä, sillä muutoin alireitit hajoavat!
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
